import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const threadsApi = createApi({
  reducerPath: "threads",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: ({ query }) => ({
    threads: query({
      query: () => ({
        url: "threads/get",
        credentials: "include",
      }),
    }),
    threadItem: query({
      query: (body) => ({
        url: "thread/getthreadextended",
        method: "POST",
        credentials: "include",
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useThreadsQuery, useThreadItemQuery } = threadsApi;
